import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import subscriptionApi from '../../api/subscription';

const initialState = {
  plans: [],
  loading: false,
  error: null,
};

export const fetchAdminPlans = createAsyncThunk(
  'adminPlans/fetchPlans',
  async (token, thunkApi) => {
    try {
      const response = await subscriptionApi.getSubscriptionPlans(token);
      return Array.isArray(response) ? response : [];
    } catch (err) {
      return thunkApi.rejectWithValue(err?.response?.data?.message || err?.message || 'Failed to fetch plans');
    }
  }
);

const adminPlansSlice = createSlice({
  name: 'adminPlans',
  initialState,
  reducers: {
    setPlans: (state, action) => {
      state.plans = action.payload;
    },
    clearPlans: (state) => {
      state.plans = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminPlans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdminPlans.fulfilled, (state, action) => {
        state.loading = false;
        state.plans = action.payload;
        state.error = null;
      })
      .addCase(fetchAdminPlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setPlans, clearPlans } = adminPlansSlice.actions;
export const selectAdminPlans = (state) => state.adminPlans.plans;
export const selectAdminPlansLoading = (state) => state.adminPlans.loading;
export const selectAdminPlansError = (state) => state.adminPlans.error;

export default adminPlansSlice.reducer; 